<template lang="pug">
PopupDefault(:isOpened="isOpened", :isInnerControls="true", theme="black", @closePopup="closePopup")
  .download-popup
    h2.download-popup__title {{ $t("download_popup.title") }}
    p.download-popup__text {{ $t("download_popup.text") }}
    .download-popup__image
      img(:src="getImageSrc" alt="Download button")
</template>

<script>
import compatibleRequire from "../../../helpers/compatibleRequire";

import PopupDefault from "./PopupDefault";

export default {
  name: "DownloadPopup",
  components: {
    PopupDefault,
  },
  computed: {
    isOpened() {
      return this.$store.getters["global/isWrongDevice"];
    },
    getImageSrc() {
      return compatibleRequire(require("../images/char.webp"));
    },
  },
  methods: {
    closePopup() {
      this.$store.commit("global/setWrongDevice", false);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../style/download-popup";
</style>
